import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { RetryLink } from '@apollo/client/link/retry'
import { withAuth } from './auth'

const graphqlUrl = import.meta.env.VITE_ENDPOINT_GRAPHQL

const retryLink = withAuth.concat(new RetryLink({
	delay: { initial: 1000 },
	attempts: { max: 3 }
}))

const requestLink = retryLink.concat(new BatchHttpLink({ uri: graphqlUrl }))

export default requestLink
